export default {"src":"/_next/static/media/no_maintenance.b808e38a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};